import { GroupDelegate } from '@leverege/molten-core';
import AttributeSortModel from "../../../filters/sort/AttributeSortModel.js";
const processBlueprints = (molten, blueprints) => {
  blueprints.forEach(blueprint => {
    molten.addPlugin('SortModel', {
      delegateType: GroupDelegate.TYPE,
      objectType: blueprint.type,
      ...AttributeSortModel
    });
  });
};
export default {
  id: 'molten.imagine.SortModelBlueprintsProcessor',
  processBlueprints
};